<template>
    <div>
        <div class="Main">
            <div class="topMain">
                <div slot="header" class="clearfix">
                    <span>告警中心</span>
                </div>
            </div>
            <div style="margin-top:10px">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="告警列表" name="1"></el-tab-pane>
                    <el-tab-pane label="告警配置" name="2"></el-tab-pane>
                </el-tabs>
            </div>
            <!-- 告警列表 -->
            <div v-if="activeName==1">
                <el-table :data="alertData" style="width: 100%">
                    <el-table-column prop="alarmName" label="告警名称" width="180" />
                    <el-table-column prop="alarmLevel" label="级别">
                        <template slot-scope="scope">
                            <span>{{scope.row.alarmLevel==1?'紧急':scope.row.alarmLevel==2?'重要':
                scope.row.alarmLevel==3?'次要':scope.row.alarmLevel==4?'提示':''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="alarmTime" label="告警时间" width="180" />
                    <el-table-column prop="alarmDescribe" label="告警描述" />
                    <el-table-column prop="devCode" label="设备编号" />
                    <el-table-column prop="devName" label="设备名称" />
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="queryParams.currentPage" :page-size="queryParams.pageSize" layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!-- 告警配置 -->
            <div v-if="activeName==2">
                <el-row :gutter="10">
                    <el-col :span="4">
                        <el-button type="primary" @click="handleCreate">创建告警规则</el-button>
                    </el-col>
                </el-row>
                <el-table :data="configureData" style="width: 100%">
                    <el-table-column prop="alarmName" label="告警规则名称" width="180" />
                    <el-table-column prop="alarmLevel" label="级别">
                        <template slot-scope="scope">
                            <span>{{scope.row.alarmLevel==1?'紧急':scope.row.alarmLevel==2?'重要':
                scope.row.alarmLevel==3?'次要':scope.row.alarmLevel==4?'提示':''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="notification" label="通知方式">
                        <template slot-scope="scope">
                            <span>{{scope.row.notification==0?'不通知':scope.row.notification==1?'手机':
                scope.row.notification==2?'邮箱':scope.row.notification==3?'手机+邮箱':''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phones" label="手机号" />
                    <el-table-column prop="emails" label="邮箱" />
                    <el-table-column prop="alarmEnable" label="是否启用">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.alarmEnable" active-color="#13ce66" inactive-color="#ff4949" @change="switchChange(scope.row)">
                            </el-switch>
                            <span> {{scope.row.alarmEnable?'启用':'禁用'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
                            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 创建弹窗 -->
        <alarmAdd ref="alarmAdd" />
    </div>
</template>
<script>
import API from "../../api/api";
import alarmAdd from './alarmAdd.vue'
export default {
    components: { alarmAdd },
    data() {
        return {
            activeName: "1",
            total: 0,
            alertData: [],
            configureData: [],
            queryParams: {
                currentPage: 1,
                pageSize: 10,
            },
        }
    },

    methods: {
        init() {
            this.getalertList()
        },
        getalertList() {
            API.platformAlarmList(this.queryParams).then(res => {
                if (res.code == 1) {
                    this.alertData = res.data.resultPage
                    this.total = res.data.total
                }
            })
        },
        getconfigList() {
            API.platformAlarmConfigList(this.queryParams).then(res => {
                if (res.code == 1) {
                    this.configureData = res.data.resultPage
                    res.data.resultPage.forEach(element => {
                        element.alarmEnable = element.alarmEnable == 1 ? true : false
                    });
                }
            })
        },
        handleClick(val) {
            if (val.paneName == 1) {
                this.getalertList()
            } else if (val.paneName == 2) {
                this.getconfigList()
            }
        },
        handleCreate() {
            this.$refs.alarmAdd.show()
        },
        handleEdit(id) {
            this.$refs.alarmAdd.showEdit(id)
        },

        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.currentPage = 1
            this.getalertList()
        },
        handleCurrentChange(val) {
            this.queryParams.currentPage = val;
            this.getalertList()
        },
        //改变状态
        switchChange(row) {
            let para = {
                alarmEnable: row.alarmEnable ? 1 : 0
            }
            API.platformAlarmConfigSwitch(row.id, para).then(res => {
                if (res.code == 1) {
                    this.$message.success("修改状态成功");
                    this.getconfigList()
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //列表信息删除
        handleDelete(row) {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    API.delplatformAlarmConfig({ ids: row.id }).then((res) => {
                        if (res.code == 1) {
                            this.$message.success("删除成功");
                            this.getconfigList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
    },
    mounted() {
        this.init();
    }
}
</script>


// WEBPACK FOOTER //
// src/views/platform/alarmCenter.vue